import type { FC } from 'react';
import { lazy } from 'react';
import { useRemitReportingEntrypoint } from 'src/apis/remit-reporting/use-remit-reporting-entrypoint';
import { PageSpinner } from 'src/components/spinner-container';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const EnterExternalTrade: FC = () => {
  const remitReportingEntrypoint = useRemitReportingEntrypoint();

  if (!remitReportingEntrypoint.response) return <PageSpinner />;

  if (
    !remitReportingEntrypoint.response.data._links?.['create-external-trade']
  ) {
    throw new Forbidden();
  }

  return (
    <Page
      organisationEic={remitReportingEntrypoint.response.data.organisationEic}
    />
  );
};
